import { Component, OnInit,Input } from '@angular/core';
import { ProductSolrDTO, SolrRequestOptionsDTO } from '@signature-it/ngx-catalogue/models';
import { SolrProductService, ProductPageService_Generic, SharedDataService } from '@signature-it/ngx-catalogue/services';

@Component({
    selector: 'context-fields',
    templateUrl: './context-fields.component.html',
    styleUrls: ['./context-fields.component.scss'],
    standalone: false
})
export class ContextFieldsComponent implements OnInit {
    @Input() item: ProductSolrDTO;
    @Input() contextId: number;
    @Input() mode: number;
    public context: any;
    public items: Array<ProductSolrDTO>;
    constructor(protected solrService: SolrProductService,
                protected productPageService: ProductPageService_Generic) {
    }

    ngOnInit() {
       // this.item = this.productPageService.mainProduct;
        this.solrService.getContext(Number(this.item.cat_group_id), this.contextId).subscribe(
            context => {
                if(context && context.data) {
                    this.context = context.data;
                }
            }
        );
    }

    convertPipe(data) {
        return data.replace(/\|/g, ",")
    }
    replaceData(data) {
        return this.replaceTextWithItemValues(data, this.item);
    }
    replaceTextWithItemValues(text: string, item): string {
        const regex = /%%([^%]+)%%/g;

        return text.replace(regex, (match, fieldName) => {
            const trimmedFieldName = fieldName.trim();

            return item[trimmedFieldName]? item[trimmedFieldName]: '';
        });
    }
}
